import { OcrProviderOption, OcrResult } from '@/modules/UseMyMoney/UseMyMoney.types';
import { storeCreator } from '@/utils/store/store.utils';

interface DocumentOcrState {
  ocrDocument?: OcrResult;
  isOcrCompleted?: boolean;
  setOcrDocument: (ocrDocument?: OcrResult) => void;
  setIsOcrCompleted: (value: boolean) => void;
  pushProvider: (provider: OcrProviderOption) => void;
  resetDocumentOcrState: () => void;
}

const DEFAULT_OPTIONS = {
  ocrDocument: undefined,
  isOcrCompleted: false,
};

const useDocumentOcrStore = storeCreator<DocumentOcrState>((set) => ({
  ...DEFAULT_OPTIONS,

  setOcrDocument: (ocrDocument?: OcrResult) => set((state) => ({
    ...state,
    ocrDocument: {
      ...state.ocrDocument,
      ...ocrDocument,
    },
  })),

  setIsOcrCompleted: (value: boolean) => set((state) => ({
    ...state,
    isOcrCompleted: value,
  })),

  pushProvider: (provider: OcrProviderOption) => set((state) => ({
    ...state,
    ocrDocument: {
      ...state.ocrDocument,
      providers: [
        ...(state.ocrDocument?.providers ?? []),
        provider,
      ],
    },
  })),

  resetDocumentOcrState: () => set((state) => ({
    ...state,
    ...DEFAULT_OPTIONS,
  })),
}));

export default useDocumentOcrStore;
